<template>
    <Settings
        v-if="settings"
        :settings="settings"
        :active-tab="activeTab"
        @updateSettings="update"
    />
</template>
<script>
import { mapActions } from "vuex";
import store from "./_store";
import Settings from "./_components/Settings.vue";
import { mutations } from "src/global-store.js";

export default {
    name: "SettingsModule",
    components: {
        Settings,
    },
    beforeRouteUpdate(to, from, next) {
        if (to.meta.activeTab && to.path) {
            this.activeTab = to.path;
        }
        next();
    },
    data() {
        return {
            activeTab: "",
            settings: null,
        };
    },
    beforeCreate() {
        this.$store.registerModule("$_settings", store);
    },
    destroyed() {
        this.$store.unregisterModule("$_settings");
    },
    async created() {
        mutations.setNavbarTitle("Portal Settings");
        this.settings = await this.fetchSettings();
        if (this.$route.meta.activeTab) {
            this.activeTab = this.$route.path || "";
        }
    },
    methods: {
        ...mapActions("$_settings", ["fetchSettings", "updateSettings"]),
        update(settings) {
            this.updateSettings(settings);
        },
    },
};
</script>
